import React from 'react';
import { useStore } from '../store';

export function CascadeTimeline() {
  const log = useStore((s) => s.cascadeLog);
  if (log.length === 0) return null;
  const last = log[log.length - 1];
  const isDone = last.kind === 'done';
  return (
    <div className="cas-tl">
      <div className="cas-tl-hd">
        Cascade {isDone ? '✓ done' : '· running'}
      </div>
      <div className="cas-tl-body">
        {log.map((e, i) => (
          <div key={i} className="cas-tl-row">
            <span className="cas-tl-ts">{new Date(e.ts).toLocaleTimeString()}</span>
            <span className="cas-tl-kind">{e.kind}</span>
            {e.stepKey && <span className="cas-tl-step">{e.stepKey}</span>}
            {e.note && <span className="cas-tl-note">— {e.note}</span>}
          </div>
        ))}
      </div>
    </div>
  );
}
